import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const GetPartyTypeList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/PartyType/GetList?` + params, null);

export const GetPartyTypeDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/PartyType/GetDetail?` + params, null);

export const CreatePartyType = (data: any) =>
  POST_ENC(`${BASE_URL}/api/PartyType/Create`, data);

export const UpdatePartyType = (data: any) =>
  POST_ENC(`${BASE_URL}/api/PartyType/Update`, data);

export const DeletePartyType = (data: any) =>
  POST_ENC(`${BASE_URL}/api/PartyType/Delete`, data);